import {useSelector} from "react-redux";

export function resolveCubeNamespace(universeKey, exploreByContact) {
    if (universeKey === 'BUSINESS') {
        return exploreByContact
            ? 'ContactContractorUniverse'
            : 'CompanyContractorUniverse';
    }
    if (universeKey === 'CONTRACTOR') {
        return exploreByContact
            ? 'TBDContractorUniverseContactExportCubeJS'
            : 'TBDContractorUniverseCompanyExportCubeJS';
    }
    return 'CompanyContractorUniverse'; // Default fallback
}

export function useCubeNamespace() {
    const currentUniverse = useSelector(state => state.universe.currentUniverse);
    const exploreByContact = useSelector(state =>
        state.universe.universes[currentUniverse]?.exploreByContact ?? false
    );

    // Call Pure Function
    return resolveCubeNamespace(currentUniverse, exploreByContact);
}
